import Image from '@/components/UI/Image';
import EFArrowDown from '@/components/UI/svg/Icons/EFArrowDown';
import { useGlobal } from '@/utils/useGlobal';
import { Collapse, Popover, Select } from 'antd';
import get from 'lodash/get';
import { useEffect } from 'react';
import css from './index.module.scss';
export default function SupportLeftMenu({
    categoryTree = [],
    fieldNames = {
        title: 'name',
        value: 'downloadCatagoryId',
        type: 'downloadCatagoryType',
    },
    onSelect,
}: any) {
    if (!categoryTree || categoryTree.length == 0) {
        return null;
    }
    const { useState, useLang } = useGlobal();
    const { t } = useLang('shared');
    const name = fieldNames.title;
    const downloadCatagoryId = fieldNames.value;
    console.log('categoryTree', categoryTree);
    /**
     * 获取所有目录树id(仅PRODUCT_CATAGORY类型)
     */
    const getAllIds = (categoryTree: any, idArr: string[] = []) => {
        categoryTree.forEach((item: any) => {
            if (item[fieldNames.type] === 'PRODUCT_CATAGORY') {
                idArr.push(item[downloadCatagoryId]);
                if (item?.subs) {
                    getAllIds(item?.subs, idArr);
                }
            }
        });
        return idArr;
    };

    // mobile: BEGIN 切换左侧tab
    // 右侧Selector三级目录数据
    const [level3Catagories, setLevel3Catagories] = useState(get(categoryTree, '0.subs.0.subs') || []);
    // 记录当前左侧selector选择项
    const [activeTree, setActiveTree] = useState(categoryTree[0]);
    // 设置左侧Selector弹窗中点击一级目录时默认的第一个二级目录的id
    const [defaultActiveId, setDefaultActiveId] = useState(-1);
    // 左侧点击选择目录事件： 带 ++ 为一级目录， 否则为二级目录
    const changeCatagory = (catagoryId: any) => {
        if (!catagoryId) {
            return;
        }
        let currentTree = '';
        if (catagoryId.indexOf('++') < 0) {
            // 一级目录， 获取当前目录，更新左侧选择框的值
            currentTree = categoryTree.filter((item: any) => item[downloadCatagoryId] === catagoryId)[0];
            setMainSelectorValue(currentTree?.name);
            setActiveTree(currentTree?.subs?.length ? currentTree?.subs[0] : currentTree);
            if (!currentTree?.subs?.length) {
                // 没有子目录，则设置右侧框为空，且关闭左侧弹框（选择框）, 更新下载列表
                setLevel3Catagories([]);
                onSelect(getAllIds([currentTree]).join(), currentTree[fieldNames.type]);
                setPopShow(false);
            } else {
                // 否则，也要更新右侧Selector的下拉框选项, 并设置默认激活状态的二级目录id
                const subsItem = currentTree?.subs[0] || {};
                setLevel3Catagories(subsItem?.subs || []);
                setDefaultActiveId(subsItem[downloadCatagoryId] || '');
            }
        } else {
            // 二级目录 获取父级（一级）目录 和 当前二级目录， 更新三级目录，取消默认激活状态的二级目录Id
            const parentId = catagoryId.split('++')[0];
            const sonId = catagoryId.split('++')[1];
            const currentParent = categoryTree.filter((item: any) => item[downloadCatagoryId] === parentId)[0];
            currentTree = currentParent?.subs?.filter((item: any) => item[downloadCatagoryId] === sonId)[0];
            setLevel3Catagories(currentTree?.subs || []);
            setActiveTree(currentTree);
            setDefaultActiveId(-1);
        }
    };
    // 左侧selector弹框的开闭
    const [popShow, setPopShow] = useState(false);
    const handleVisibleChange = (visible: boolean) => {
        setPopShow(visible);
    };
    // 右侧selector下拉框的开闭
    const [selectOpen, setSelectOpen] = useState(false);
    const changeVisibleDropdown = (visible: boolean) => {
        setSelectOpen(visible);
    };
    // 点击左侧Selector弹框中的OK按钮
    const onOk = () => {
        let catagoryIdsStr, type;
        if (activeTree?.subs?.length) {
            catagoryIdsStr = activeTree?.subs[0][downloadCatagoryId];
            type = activeTree?.subs[0][fieldNames.type];
            setSubSelectorValue(level3Catagories[0].name);
        } else {
            catagoryIdsStr = activeTree[fieldNames.type] === 'PRODUCT_CATAGORY' ? getAllIds([activeTree]).join() : activeTree[fieldNames.value];
            type = activeTree[fieldNames.type];
            setSubSelectorValue('');
        }
        onSelect(catagoryIdsStr, type);
        setPopShow(false);
    };
    // 右侧Selector展示的值
    const [subSelectorValue, setSubSelectorValue] = useState(level3Catagories?.length && level3Catagories[0][name]);
    // 右侧Selector点击选择事件
    const tabChange = (value: any) => {
        setSelectOpen(false);
        const selectItem = level3Catagories.find((list: any) => list[fieldNames.value] === String(value));
        onSelect(String(value), selectItem[fieldNames.type]);
        setSubSelectorValue(level3Catagories.filter((item: any) => item[downloadCatagoryId] === value)[0]?.name);
    };
    // 三级目录变动时，重新设定右侧Selector展示的值
    useEffect(() => {
        setSubSelectorValue(level3Catagories?.length && level3Catagories[0][name]);
    }, [level3Catagories]);
    // 左侧Selector展示的值
    const [mainSelectorValue, setMainSelectorValue] = useState(categoryTree[0]?.name);
    // moile: END

    return (
        <div className={css.supportLeftMenu}>
            <div className="downloadBox">
                <div className="selectorBox">
                    <div className="leftSelector">
                        <Popover
                            overlayClassName="download-dropdown-h5"
                            placement="bottom"
                            content={
                                <div className="downloadPopoverBox">
                                    <ul className="categoryLists">
                                        <Collapse
                                            expandIconPosition={'right'}
                                            onChange={changeCatagory}
                                            destroyInactivePanel
                                            accordion
                                            ghost
                                            defaultActiveKey={[1]}
                                            expandIcon={({ isActive }) => (
                                                <div className="minusPlusIconBox">
                                                    <Image
                                                        src={isActive ? '/icons/mobileH5/minus_black_h5.svg' : '/icons/mobileH5/plus_black_h5.svg'}
                                                        layout="fill"
                                                        className="fullImgs"
                                                        alt={isActive ? t('support.download.minus') : t('support.download.plus')}
                                                    />
                                                </div>
                                            )}
                                        >
                                            {categoryTree.map((category: any, k: number) => (
                                                <Collapse.Panel
                                                    header={category[name]}
                                                    key={String(category[downloadCatagoryId])}
                                                    showArrow={category?.subs?.length > 0}
                                                >
                                                    {category?.subs?.length && (
                                                        <div className="subLists">
                                                            <Collapse onChange={changeCatagory} accordion ghost defaultActiveKey={[1]}>
                                                                {category?.subs?.map((sub: any, i: number) => (
                                                                    <Collapse.Panel
                                                                        className={defaultActiveId === sub[downloadCatagoryId] ? 'defaultActiveCls' : ''}
                                                                        header={sub[name]}
                                                                        key={`${category[downloadCatagoryId]}++${sub[downloadCatagoryId]}`}
                                                                        showArrow={false}
                                                                    ></Collapse.Panel>
                                                                ))}
                                                            </Collapse>
                                                        </div>
                                                    )}
                                                </Collapse.Panel>
                                            ))}
                                        </Collapse>
                                    </ul>
                                    <div className="btnBox">
                                        <div className="okBtn" onClick={onOk}>
                                            {t('common.confirm_text')}
                                        </div>
                                    </div>
                                </div>
                            }
                            trigger="click"
                            visible={popShow}
                            onVisibleChange={handleVisibleChange}
                        >
                            <div className="leftSelectText font-family-semibold">
                                {mainSelectorValue}
                                <div className={`iconBox ${popShow ? 'open' : ''}`}>
                                    <EFArrowDown
                                        style={{
                                            fontSize: '.12rem',
                                            marginTop: '0.03rem',
                                            marginLeft: '0.03rem',
                                        }}
                                    />
                                </div>
                            </div>
                        </Popover>
                    </div>
                    <div className="rightSelector" style={{ display: level3Catagories.length ? 'inline-block' : 'none' }}>
                        <Select
                            className="download_selector_h5"
                            value={subSelectorValue}
                            showArrow
                            suffixIcon={
                                <div className={`iconBox ${selectOpen ? 'open' : ''}`}>
                                    <EFArrowDown
                                        style={{
                                            fontSize: '.12rem',
                                            marginTop: '0.03rem',
                                            color: '#000',
                                        }}
                                    />
                                </div>
                            }
                            // suffixIcon={
                            //     <Icon component={EFArrowDown} />
                            // }
                            onChange={tabChange}
                            onDropdownVisibleChange={changeVisibleDropdown}
                        >
                            {level3Catagories?.map((catagory: any, k: number) => (
                                <Select.Option value={catagory.value} key={catagory[downloadCatagoryId]}>
                                    {catagory[name]}
                                </Select.Option>
                            ))}
                        </Select>
                    </div>
                </div>
            </div>
        </div>
    );
}
